<template>
  <div
    class="widgetType"
  >
    <div
      class="widgetType__title"
    >
      <div style="width: 20%">
        <v-btn
          icon
        >
          <v-icon
            large
            color="black"
            class="widgetType__body__icon"
          >
            mdi-drag
          </v-icon>
        </v-btn>
      </div>
      <div class="widgetType__title__text">
        {{ $t(`siteDashboard.${widgetName.charAt(0).toLowerCase() + widgetName.slice(1)}`) }}
      </div>
    </div>
    <div
      class="widgetType__body"
    >
      <div
        class="widgetType__body__icon"
      >
        <v-icon
          :color="widgetIconColor"
          xLarge
        >
          {{ widgetIconName }}
        </v-icon>
      </div>
      <div
        class="widgetType__body__text"
      >
        {{ $t(widgetDescription) }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
    name: 'WidgetType',
    props: {
        widgetName: {
            type: String,
            default: '',
        },
        widgetIconName: {
            type: String,
            default: '',
        },
        widgetDescription: {
            type: String,
            default: '',
        },
        widgetIconColor: {
            type: String,
            default: 'black',
        },
    },
};
</script>

<style scoped lang="scss">
.widgetType {
    width: 100%;
    height: 100px;
    padding: 1px;
    &__title {
        display: flex;
        flex-direction: row;
        text-align: left;
        align-items: center;
        &__text {
          width: 80%;
            font-weight: 600;
            font-size: 18px;
            margin-left: 10px;
            line-height: 1;
        }
    }
    &__body {
        width : 100%;
        display: flex;
        flex-direction: row;
        margin-top: 15px;
        align-items: center;

        &__icon {
            width: 20%;
            margin-right: 10px;
        }
        &__text {
            width: 80%;
            text-align: left;
        }
    }
}


</style>
